/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {matchContacts} from '../api'

export const useMutationMatchContacts = createReactQueryMutationHook('matchContacts', matchContacts)
